import { throttle } from "lodash";
import React, { useContext } from "react";
import { SketchPicker } from "react-color";
import { GrigoraDashboardContext } from "../dashboard/context";
import "./globalsketchpicker.scss";
function GlobalSketchPicker({ value, onChange, hidePresets = true }) {
  const { project } = useContext(GrigoraDashboardContext) ?? {};

  const handleColorChange = (e) => {
    const temp =
      e.rgb.a === 1
        ? e.hex
        : `rgba(${e.rgb.r}, ${e.rgb.g}, ${e.rgb.b}, ${e.rgb.a})`;
    onChange(temp);
  };

  const throttledColorChange = throttle(handleColorChange, 300);

  return (
    <>
      <SketchPicker
        className="grigora-color-sketch-picker-ui-kit"
        color={value}
        onChange={throttledColorChange}
        presetColors={[]}
      />
      <div className="flex w-48 flex-wrap gap-3 mt-2">
        {hidePresets &&
          project?.colors &&
          Array.isArray(project?.colors) &&
          project?.colors?.map((item, i) => {
            return (
              <div
                key={`${item}-${i}`}
                title={item.title}
                className="w-[20px] h-[20px] p-[2px] border rounded-[4px] overflow-hidden cursor-pointer"
                style={{
                  borderColor:
                    value === `var(--gb--${item.title})` ? "black" : undefined,
                }}
                onClick={(e) => {
                  onChange(`var(--gb--${item.title})`);
                }}
              >
                <div
                  className="w-full h-full rounded-[2px]"
                  style={{
                    backgroundColor: item.color ? item.color : "transparent",
                  }}
                ></div>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default GlobalSketchPicker;
